import { FORM_FIELDS } from '../../../../../../../../constants';
import { getValidationSchema } from '../../../../../../../form/common.validators';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.EDUCATION,
        FORM_FIELDS.FAMILY_STATUS,
        FORM_FIELDS.ADDITIONAL_PHONE,
        FORM_FIELDS.ADDITIONAL_PHONE_OWNER,
        FORM_FIELDS.ADDITIONAL_PHONE_OWNER_FIO,
        FORM_FIELDS.NUMBER_OF_DEPENDENTS,
        FORM_FIELDS.SNILS,
        FORM_FIELDS.ADDITIONAL_INCOME,
        FORM_FIELDS.PROPERTY_TYPE,
        FORM_FIELDS.CAR,
    ]);
